// Called by : src/components/lesson/CourseItem.vue (lesson-item)

<template>
  <div class="row lesson item_lesson" v-if="lesson.visible">

    {{ forceUpdate }}

    <div class="div_lec_img col-2 text-left px-0 d-none d-sm-inline">
      <img :src="lesson.urlImage" :alt="getImageName()" ref="rVgt" class="lec_img" width="150" height="75" @error="onVignetteError()">
    </div>
    
    <div class="div_lec_name col-8 col-sm-7 text-left px-0">

      <p class="lec_name my-1">
        <span class="text-muted d-none d-md-inline">{{ $t('lesson.name') }}</span>
        <sound-player :url="lesson.audioTitle" role="lessonList" tone="btn-outline-primary"></sound-player>
        <strong>{{ lesson.name }}</strong>
      </p>

      <p class="lec_train font-italic my-1">
        <span class="text-muted d-none d-md-inline">{{ $t('lesson.skillName') }}</span>
        <strong>{{ lesson.skillName }}</strong>
      </p>

    </div> <!-- .div_lec_name -->

    <div class="div_lec_job col-4 col-sm-3 text-center px-0">

      <p class="div_lec_flag my-0 py-0">
        <span class="text-muted d-none d-md-inline">{{ $t('lesson.lang') }}</span>
        <country-flag :country="flag" :title="lesson.langInfos" class="ui_tip lec_flag" />
        <small class="lec_lang text-muted text-uppercase font-weight-bold ml-0 ml-md-2">{{ lesson.lang }}</small>
      </p>

      <div v-if="isLessonEval" class="div_lec_btns btn-group btn-block mt-1" data-toggle="buttons">

        <button v-if="isLessonInit" @click="setReset(true)" class="lec_btn_init ui_tip btn btn-success" v-bind:title="tipLessonInit" data-toggle="modal" :data-target="'#modal_eval_' + lesson.zkp">
          <span class="oi oi-loop-circular" style=""></span>
        </button>

        <button @click="setReset(false)" class="lec_btn_job ui_tip btn btn_lec_eval " :class="btnProps('color')" v-bind:title="$t(btnProps('label'))" data-toggle="modal" :data-target="'#modal_eval_' + lesson.zkp">
          <span class="oi mr-lg-2" :class="btnProps('icon')" style=""></span>
          <span class="d-none d-lg-inline">{{ $t(btnProps('label')) }}</span>
        </button>

      </div> <!-- .div_lec_btns -->

      <div v-else class="div_lec_btns btn-group btn-block mt-1" data-toggle="buttons">

        <button v-if="isLessonInit" @click="resetLesson()" class="lec_btn_init ui_tip btn btn-success" v-bind:title="tipLessonInit">
          <span class="oi oi-loop-circular" style=""></span>
        </button>

        <button @click="goQuestion()" class="lec_btn_job ui_tip btn " :class="btnProps('color')" v-bind:title="$t(btnProps('label'))" v-bind:rel="infos">
          <span class="oi mr-lg-2" :class="btnProps('icon')" style=""></span>
          <span class="d-none d-lg-inline">{{ $t(btnProps('label')) }}</span>
        </button>

        <button v-if="isCoachValidation" @click="coachValidation" class="lec_btn_val ui_tip btn btn-success" v-bind:title="tipCoachValidation" style="">
          <span class="oi oi-star" style="color:#fe0;"></span>
        </button>

      </div> <!-- .div_lec_btns -->

    </div> <!-- .div_lec_job -->

    <modal-eval v-if="isLessonEval" @save="save" :key="keyEval" :pass="passEval" :zkp="lesson.zkp"></modal-eval>

  </div> <!-- .item_lesson -->
</template>

<script>
import { constants } from '@/constants'
import CountryFlag from "vue-country-flag"
import SoundPlayer from '@/components/misc/SoundPlayer'
import ModalEval from '@/components/misc/ModalEval'
import ModalTest from '@/components/misc/ModalTest'

export default {
  name: 'LessonItem',
  components: {
    CountryFlag,
    SoundPlayer,
    ModalEval,
    ModalTest,
  },
  props: {
    lesson: Object,
  },
  data() {
    return {
      btn: {
        // @todo : update according to lesson.state
        label: "lesson.btnTodo",
        active: true,
      },
      flag: this.lesson.country,
      isLessonInit: false,
      isReset: false,
      isCoachValidation: false,
      isLessonEval: false,
      tipLessonInit: this.$t('lesson.tipLessonInit'),
      tipCoachValidation: this.$t('lesson.tipCoachValidation'),
      keyEval: false,
      passEval: '',
      aLabels: ['lesson.btnTodo','lesson.btnTodo','lesson.btnResume','lesson.btnDone','lesson.btnRestart','lesson.btnWait','lesson.btnEval','lesson.btnEval'],
      aIcons: ['oi-media-play','oi-media-play','oi-media-pause','oi-check','oi-reload','oi-clock','oi-star','oi-check'],
      aColors: ['btn-primary','btn-primary','btn-info','btn-success disabled','btn-secondary','btn-secondary disabled','btn-warning','btn-warning disabled'],
      infos: '',
      msg: '',
    }
  },
  methods: {
    getKey(sId) {
      return sId + f_getRandomMinMax_n(100000000, 999999999);
    },
    getImageName() {
      return f_getUrlFileName_s(this.lesson.urlImage);
    },
    onVignetteError() {
      let oVgt = this.$refs.rVgt;
      oVgt.src = this.constants.assets.fondVertMiniJpgFile;
    },
    goQuestion() {
      var isResume = Boolean(this.state === this.constants.lessonState.resume);
      let isNotDone = Boolean(this.state != this.constants.lessonState.done);
      let isNotWait = Boolean(this.state != this.constants.lessonState.wait);
      // let isNotEval = Boolean(!this.isLessonEval);  && isNotEval

      if (isNotDone && isNotWait) {
        this.isReset = false;
        var currLesson = this.lesson
        currLesson.questions = []
        this.$store.commit('setLesson', currLesson)
        this.$store.commit('setLessonStart', Date.now());
        this.$router.push({name: 'question'});
        if (isResume) {
          f_setQstZkpAll_v(this.lesson.histoQstZkp);
        } else {
          f_cleanQstZkpPrev_v();
        }
      }
      /*
      console.log('**********');
      console.log('state', this.state.toString());
      console.log('isResume', isResume.toString());
      console.log('isNotDone', isNotDone.toString());
      console.log('isNotWait', isNotWait.toString());
      console.log('**********');
      */
    },
    save(sPassEval, event = null) {
      if (event) event.stopPropagation();
      let result = !Boolean(this.passEval.localeCompare(sPassEval));
      // console.log('passEval', result.toString());
      if (result) {
        if (this.isReset) {
          this.resetLesson();
        } else {
          this.goQuestion();
        }
      }
    },
    btnProps(propType) {
      // https://useiconic.com/open
      let nState = (isNaN(parseInt(this.state,10))) ? 0 : parseInt(this.state,10);
      let nEval = this.constants.lessonState.eval;
      let nVal = (this.isLessonEval) ? nEval : nState;
      let nItm = ((this.isLessonEval) && (nState == 3)) ? 7 : nVal;

      if (propType == 'label') return this.aLabels[nItm];
      if (propType == 'icon') return this.aIcons[nItm]; 
      if (propType == 'color') return this.aColors[nItm];
      return ''

      /*
        lessonState: {
          todo: 1, // à faire : première fois
          resume: 2, // en cours : à terminer
          done: 3, // terminée : non renouvelable
          restart: 4, // terminée : renouvelable
          wait: 5, // en attente : sequentiel
          eval: 6, // leçon d'évaluation
        	evaldone: 7, // leçon d'évaluation finie
      },
      
      aLabels: ['lesson.btnTodo','lesson.btnTodo','lesson.btnResume','lesson.btnDone','lesson.btnRestart','lesson.btnWait','lesson.btnEval','lesson.btnEval'],
      aIcons: ['oi-media-play','oi-media-play','oi-media-pause','oi-check','oi-reload','oi-clock','oi-star','oi-check'],
      aColors: ['btn-primary','btn-primary','btn-info','btn-success disabled','btn-secondary','btn-secondary disabled','btn-warning','btn-warning disabled'],

      let aLabels = ['lesson.btnTodo','lesson.btnTodo','lesson.btnResume','lesson.btnDone','lesson.btnRestart','lesson.btnWait','lesson.btnEval'];
      let aIcons = ['oi-media-play','oi-media-play','oi-media-pause','oi-check','oi-reload', 'oi-clock', 'oi-star'];
      let aColors = ['btn-primary','btn-primary','btn-info','btn-success disabled','btn-secondary','btn-primary disabled', 'btn-warning'];
      if (propType == 'label') return (this.isLessonEval) ? aLabels[nEval] : aLabels[nState];
      if (propType == 'icon') return (this.isLessonEval) ? aIcons[nEval] : aIcons[nState];
      if (propType == 'color') return (this.isLessonEval) ? aColors[nEval] : aColors[nState];
      */
    },
    setReset(bVal) {
      this.isReset = bVal;
      f_setModalEvalZkp_v(this.lesson.zkp);
    },
    resetLesson() {
      this.isReset = false;
      this.model.runScript('LAPR_js', '2022_VUEJS_LeconUne_Init', this.lesson.zkp_lapr)
      // this.model.getAssignments(this.user.zkp)

      // bascule vers "Patience.vue"
      var oParams = {
        sTitlePage: this.lesson.name,
        sTextHeader: this.$t("patience.init"),
        sTextFooter: null,
        nTimeout: this.params.patienceTime,
        sRouteName: null,
      };
      this.$router.push({ name: 'patience', params: oParams });

    },
    coachValidation() {
      this.$router.push({ name: 'validation', params: {
        user: this.user,
        lesson: this.lesson,
      }})
    }
  },
  computed: {
    model() {
      return this.$store.state.model
    },
    params() {
      return this.$store.state.params
    },  
    constants() {
      return constants
    }, 
    user() {
      return this.$store.state.user
    },
    state() {
      return (
        this.lesson.currQstZkp 
        ? this.constants.lessonState.resume 
        : this.lesson.state
      )
    },
    forceUpdate() {
      if (!this.keyEval) this.keyEval = this.getKey('keyEval');

      let isTodo = Boolean(this.state == this.constants.lessonState.todo);
      let isWait = Boolean(this.state == this.constants.lessonState.wait);
      let isEval = Boolean(this.state == this.constants.lessonState.eval);
      let isEvalEnd = Boolean(this.state == this.constants.lessonState.evaldone);

      this.isLessonInit = Boolean(this.params.canResetLesson && this.lesson.isLecInit && !isTodo && !isWait && !isEval);
      // @install : comparaison 
      // || en dev
      // && en prod
      this.isCoachValidation = Boolean(this.lesson.coachMustValid && isTodo);
      this.isLessonEval = Boolean(this.lesson.isEvaluation); //  && isEval
      this.isReset = false;

      this.tipLessonInit = this.$t("lesson.tipLessonInit")
      this.tipCoachValidation = this.$t("lesson.tipCoachValidation")

      // this.passEval = this.lesson.passEval;
      this.passEval = (Boolean(this.lesson.forPass.length)) ? this.lesson.forPass : this.lesson.passEval;

      // this.infos = this.lesson.ordre + '. ' + this.lesson.name + ' ( ' + this.lesson.zkp + ' )'
      this.infos = this.lesson.ordre + '. ' + this.lesson.zkp + ' ( ' + this.lesson.state + ' )';
      console.log('infos',this.infos);

      /*
      console.log('——————————');
      console.log('eval_state', isEval.toString());
      console.log('eval_lesson', this.isLessonEval.toString());
      console.log('eval_pass', this.lesson.passEval.toString());
      console.log('for_pass', this.lesson.forPass.toString());
      console.log('pass_eval', this.passEval.toString());
      console.log('——————————');
      */

      return '';
    },
    mounted() {
      this.keyEval = false;
      let oVgt = this.$refs.rVgt
    },
  }
}
</script>

<style scoped>
#alttext{
  font-size: 0.5rem !important;
}
.lesson {
    padding: 1rem;
    border: 1px solid #fff;
    background-color:#f0f2f4;
}
.lesson p {
  font-size: 1.25em;
}
.lec_img {
  border: 1px solid #999;
  object-fit: fill;
}
.btn_lec_eval.active {
  color: #212529 !important;
  background-color: #ffc107 !important;
  border-color: #ffc107 !important;
}
.btn_lec_eval.active:hover {
  color: #212529 !important;
  background-color: #e0a800 !important;
  border-color: #d39e00 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/lesson/LessonItem.vue